var map = {
	"./Galaxy": 3016,
	"./Galaxy.js": 3016,
	"./GalaxySystem": 6772,
	"./GalaxySystem.js": 6772,
	"./UniverseApp": 7378,
	"./UniverseApp.css": 7658,
	"./UniverseApp.js": 7378,
	"./calculateDistance.py": 7717,
	"./data/123-transformed.glb": 3421,
	"./data/universe": 6896,
	"./data/universe.json": 6896,
	"./image/galaxy.png": 5788,
	"./image/milkyway.png": 8835,
	"./systems/HelixNebula": 3549,
	"./systems/HelixNebula.js": 3549,
	"./systems/NebulaSystems": 7794,
	"./systems/NebulaSystems.js": 7794,
	"./systems/tempRecod": 5612,
	"./systems/tempRecod.json": 5612,
	"./universeComponent/Controllers": 465,
	"./universeComponent/Controllers.css": 7574,
	"./universeComponent/Controllers.js": 465,
	"./universeComponent/GalaxyModalView": 3836,
	"./universeComponent/GalaxyModalView.css": 1998,
	"./universeComponent/GalaxyModalView.js": 3836,
	"./universeComponent/TabView": 7982,
	"./universeComponent/TabView.css": 9034,
	"./universeComponent/TabView.js": 7982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1068;